import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RatingComponent } from './rating.component';
import {IonicModule} from "@ionic/angular";
import {TablerIconsModule} from "angular-tabler-icons";



@NgModule({
  declarations: [
    RatingComponent
  ],
    imports: [
        CommonModule,
        IonicModule,
        TablerIconsModule
    ],
  exports:[
      RatingComponent
  ]
})
export class RatingModule { }
